import styled from "styled-components";
import { Modal } from "antd";

const StyledModal = styled(Modal)`
  &.ant-modal {
    .ant-modal-content {
      padding: 32px;
    }

    .ant-modal-header {
      margin-bottom: 32px;
    }

    .ant-modal-title {
      color: #1e1919;
      font-size: 18px;
    }

    .ant-modal-body {
      text-align: center;
    }

    .ant-modal-footer {
      margin-top: 32px;
    }
  }
`;

export default StyledModal;
